export const FRANCHISE_LOGIN_SCREEN = "/login";
export const FRANCHISE_OTP_SCREEN = "/otp";
export const FRANCHISE_DASHBOARD_SCREEN = "/";
export const REVENUE_SUMMARY_SCREEN = "/revenue-summary";
